<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        id="loadingDevTroca"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div id="idDevolucaoTroca">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <canvas
              id="myChartDevolucaoTotalTroca"
            />
            <div
              v-if="enableTroca"
              id="textoTrocaId"
              class="text-center"
            >
              TROCA
            </div>
          </v-col>
        </v-row>
        <v-row v-if="enableTroca">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <div
              id="valorTroca"
              class="text-center"
            >
              VALOR TOTAL <span :style="styleFaturamento">{{ valorTroca }}</span>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'

  export default {
    name: 'ShowMeta',
    emits: ['enableDevolucaoTroca'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
      loading: false,
      error: null,
      dados: [],
      vendedores: [],
      selectMes: [],
      selectAno: [],
      myChart: {},
      valorTroca: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      enableTroca: false,
      labelsTroca: [],
      troca: [],
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)

      eventEmit.$on('enable-troca', this.handleUpdateGrafico)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)

      eventEmit.$off('enable-troca', this.handleUpdateGrafico)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorTroca = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.enable = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        this.showTotalTroca()
      },

      handleUpdateGrafico (valorTroca, labelsTrocaTotal, quantidadetrocaTotal) {
        this.valorTroca = valorTroca

        const ctx = document.getElementById('myChartDevolucaoTotalTroca').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: labelsTrocaTotal,
            datasets: [
              {
                label: 'Devolução',
                data: quantidadetrocaTotal,
                backgroundColor: '#4780b8',
                order: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  gridLines: {
                    display: true,
                  },
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  display: false,
                  barPercentage: 0.2,
                },
              ],
            },
            legend: {
              display: false,
              position: 'right',
              labels: {
                fontSize: 10,
                generateLabels: function (chart) {
                  return [
                    {
                      text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                      fillStyle: '#4780b8',
                    },
                  ]
                },
              },
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                },
                title: (tooltipItem) => {
                  return labelsTrocaTotal[tooltipItem[0].index]
                },
              },
            },
          },
        })
      },

      async showTotalTroca () {
        this.loading = true
        this.error = false

        await Comercial.showDevolucaoTroca(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorTroca = resposta.data.devolucao[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.enableTroca = true

            this.labelsTroca = resposta.data.labels
            this.troca = resposta.data.devolucao

            const ctx = document.getElementById('myChartDevolucaoTotalTroca').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Devolução',
                    data: resposta.data.devolucao,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  yAxes: [
                    {
                      gridLines: {
                        display: true,
                      },
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                  xAxes: [
                    {
                      gridLines: {
                        display: false,
                      },
                      display: false,
                      barPercentage: 0.2,
                    },
                  ],
                },
                legend: {
                  display: false,
                  position: 'right',
                  labels: {
                    fontSize: 10,
                    generateLabels: function (chart) {
                      return [
                        {
                          text: chart.data.datasets[0].data[0].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                          fillStyle: '#4780b8',
                        },
                      ]
                    },
                  },
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há devoluções para os filtros selecionados') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)

            this.error1 = resposta.data.text
          } else if (resposta.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.error1 = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('enable-devolucao-troca', this.labelsTroca, this.troca, this.valorTroca)
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #idDevolucaoTroca {
      margin: 0 0 0 0;
    }

    #valorTroca {
      margin: -1rem 0 0 -5rem;
    }

    #myChartDevolucaoTotalTroca {
      height: 248px !important;
      width: 321px !important;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    #myChartDevolucaoTotalTroca {
      width: 262px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem !important;
    }

    #valorTroca {
      margin: -1rem 0 0 -3rem;
      font-size: 14px;
    }
  }

  @media screen
  and (min-width: 1902px) {
    #myChartDevolucaoTotalTroca {
      width: 308px !important;
      height: 303px !important;
      margin: 2rem 0 0 -2rem !important;
    }
  }
</style>

<style lang="sass">
  #loadingDevTroca
    margin: 5rem 0 0 -10rem

  #idDevolucaoTroca
    margin: 0 0 0 -7rem

  #valorTroca
    margin: -1rem 0 0 -6rem
    font-size: 14px

  #myChartDevolucaoTotalTroca
    width: 230px !important
    height: 220px !important
    margin: 0 0 0 -2rem !important

  #textoTrocaId
    margin: 0 0 0 -3rem

  @media print
    #myChartDevolucaoTotalTroca
      width: 180px !important
      height: 220px !important
      margin: 0 0 0 14rem !important

    #valorTroca
      font-size: 12px !important
      margin: 0 2rem 0 -1rem !important

    #textoTrocaId
      margin: 0 2rem 0 -4rem !important
</style>
